import React from "react"
import Back from "../common/Back"
import Heading from "../common/Heading"
import img from "../images/about.jpg"
import "./about.css"
import { useLanguage } from "../../context/LanguageContext"

const About = () => {
  const { content } = useLanguage()
  const { about, assets } = content

  return (
    <>
      <section className='about'>
        <Back name={about.backName} title={about.backTitle} cover={img} />
        <div className='container flex mtop'>
          <div className='left row'>
            <Heading title={about.storyTitle} subtitle={about.storySubtitle} />

            <p>{about.paragraphs[0]}</p>
            <p>{about.paragraphs[1]}</p>
            <button type='button' className='btn2'>
              {about.button}
            </button>
          </div>
          <div className='right row'>
            <img src={assets.aboutIllustration} alt={about.imageAlt} />
          </div>
        </div>
      </section>
    </>
  )
}

export default About
